<!--消息推送-->
<template>
    <div>
        <van-nav-bar :title="title"/>
        <div class="pm-panel" >
            <van-cell-group>
                <van-field
                        v-model="formModel.title"
                        label="标题"
                        placeholder="请输入标题"
                        required
                />
            </van-cell-group>

            <van-cell-group>
                <van-field
                        v-model="formModel.desc"
                        rows="2"
                        autosize
                        label="描述"
                        type="textarea"
                        maxlength="50"
                        placeholder="请输入备注"
                        show-word-limit
                        required
                />
            </van-cell-group>
            <van-cell-group>
                <van-row type="flex" >
                    <van-col span="6" >
                        <van-field label="目标用户" readonly required/>
                    </van-col>
                    <van-col span="18">
                        <van-cell>
                        <van-checkbox-group v-model="formModel.user_ids" direction="horizontal" >
                            <van-checkbox shape="square" checked-color="#fe7844" :key ="item.attrId" :name="item.attrId" icon-size="18px" v-for="item in users">{{item.attrName}}</van-checkbox>
                        </van-checkbox-group>
                        </van-cell>
                    </van-col>

                </van-row>

            </van-cell-group>
            <van-cell-group>
                <van-button style="margin-top: 10px;" type="primary"
                            block round color="#fe7844" :loading="isLoading"
                            loading-text="推送中..."
                            @click="submitForm">推送消息</van-button>
            </van-cell-group>
        </div>
    </div>

</template>

<script>


    import * as DateUtil from '@/common/utils/dateUtil.js'
    import * as MyApi from '@/api/URLApiAddr.js'
    import store from '@/store'

    export default {
        name: "PushMsg",
        data() {
            return {
                title: '推送消息',
                formModel: {
                    title: '',
                    desc: '',
                    user_ids: []
                },
                isLoading: false,
                users: []
            }
        },
        created:function() {
            this.initMsgData()
        },
        methods:{
            initMsgData(){
                let params = {attrIds:[17]}
                this.$axios.post(MyApi.QRY_ATTR_LIST_BY_PARID,params).then((resp) => {
                    let payers = resp.data.payer
                    this.users = payers

                }).catch((error) => {
                    console.log(error)
                    this.$toast.fail("数据初始化异常");
                })
            },
            submitForm() {
                this.isLoading = true
                let params = this.formModel
                this.$axios.post(MyApi.PUSH_QUICK_MSG,params/*,options*/)
                    // 请求成功后
                    .then((data) => {
                        //let data = response.data;
                        if('200' == data.code){
                            this.formModel.title = ''
                            this.formModel.desc = ''
                            this.formModel.user_ids = []
                            this.$toast.success(data.msg);
                        }
                        this.isLoading = false
                    })
                    .catch((err) => {
                        this.$toast.fail("请求异常,请稍后再试" + err);
                    })
            },
            onUserConfirm(value) {
                this.formModel.date = DateUtil.formatDate(value,'yyyy-MM-dd');
                this.showDatePicker = false;
            }
        }
    }
</script>

<style scoped>

</style>
